'use strict';

angular.module('shiftTraderApp')
    .directive('saFooterDayArea', function ($compile, $timeout, $filter, $rootScope, UtilityService, OverlayManagementService) {
      var tooltipTemplate = '<div class="footer_day_area_tooltip sa_footer_tooltip_wrapper" ' +
        'sa-footer-day-information-area="dayAnalysis.departmentData" org="org" dt-twix="dayAnalysis.dateTwix"></div>';
      return {
        templateUrl: 'views/directives/saFooterDayArea.html',
        restrict: 'A',
        scope: {
          index: '@',
          org: '=',
          date: '='
        },
        link: function link (scope, elem) {
          var publishStatusBarElem = $(elem).find('.footer_budget_publish_status_bar');

          var openDelay = 300;

          var tooltipTemplateLinker = $compile(tooltipTemplate);

          var tooltipOpenState = false;
          var tooltip;
          var tappedOpen;
          var tooltipTimeout;

          function setPublishStatusBarClasses() {
            var classesToAdd = [];

            publishStatusBarElem.removeClass('all_published not_all_published has_no_shifts');

            if (scope.loadCompleted && scope.dayPublishData && scope.dayPublishData.dayPublished && !scope.dayPublishData.dayNotAllPublished) {
              classesToAdd.push('all_published');
            }

            if (scope.loadCompleted && scope.dayPublishData && (scope.dayPublishData.dayNotAllPublished && scope.dayPublishData.dayHasShifts || scope.dayPublishData.dayHasUnassigned)) {
              classesToAdd.push('not_all_published');
            }

            if (scope.loadCompleted && scope.dayPublishData && !scope.dayPublishData.dayHasShifts && !scope.dayPublishData.dayHasUnassigned) {
              classesToAdd.push('has_no_shifts');
            }

            if (classesToAdd.length > 0) {
              publishStatusBarElem.addClass(classesToAdd.join(' '));
            }
          }

          var positionTooltip = function () {
            var tooltipIndicatorArrow = $(tooltip).find('.sa_footer_day_down_arrow');
            var dayAreaHeight = $(elem).outerHeight();
            var dayAreaWidth = $(elem).outerWidth();
            var arrowHeight = 10;

            var tooltipWidth = tooltip.outerWidth();

            tooltip.css({
              top: dayAreaHeight + arrowHeight,
              left:  (-1 * tooltipWidth + dayAreaWidth)/ 2.0
            });
          };

          var hoverIn = function () {
            if (scope.loadCompleted) {
              $(elem).addClass('hovering');
              if (!tooltipOpenState) {
                toggleTooltipOpen();
              }
            }
          };

          var hoverOut = function () {
            if (scope.loadCompleted) {
              $(elem).removeClass('hovering');

              if (!tappedOpen) {
                closeTooltip(true);
              }
            }
          };

          var openTooltip = function () {
            if (!tooltipTimeout) {
              tooltipTimeout = $timeout(function() {
                tooltip = tooltipTemplateLinker(scope, function () {});
                tooltip.css({bottom: 0, left: 0, display: 'block', 'z-index': 11000});
                elem.append( tooltip );
                positionTooltip();
                scope.$digest();
                tooltipOpenState = true;
                $timeout(function() {
                  tooltip.addClass('active');
                  OverlayManagementService.addOverlay('mwpGuideBar', scope.index, function() {
                    closeTooltip(true);
                    tappedOpen = false;
                  });
                }, 0);

              }, openDelay);
            }
          };

          var closeTooltip = function (animate) {
            tooltipOpenState = false;
            $timeout.cancel(tooltipTimeout);
            tooltipTimeout = undefined;
            if (tooltip) {
              if (animate) {
                tooltip.removeClass('active');
                OverlayManagementService.removeOverlay('mwpGuideBar', scope.index);
                $timeout(function() {
                  if (tooltip) {
                    tooltip.remove();
                  }
                  tooltip = null;
                }, 300);
              } else {
                OverlayManagementService.removeOverlay('mwpGuideBar', scope.index);
                tooltip.remove();
                tooltip = null;
              }
            }

          };

          var toggleTooltipOpen = function () {
            if (!tooltipOpenState) {
              openTooltip();
            } else {
              closeTooltip(true);
            }
          };

          var bindClicks = function() {
            //console.log('bind clicks');
            $(elem).bind('mousedown touchdown', function (event) {
              //console.log('bound click fn');
              if (scope.loadCompleted) {
                if (tooltipOpenState) {
                  tappedOpen = false;
                } else {
                  tappedOpen = true;
                }

                toggleTooltipOpen();
                event.stopPropagation();
              }
            });
          };


          if (!$rootScope.isIpad) {
            $(elem).hover(hoverIn, hoverOut);
          }

          // Make sure tooltip is destroyed and removed.
          scope.$on('$destroy', function onDestroyTooltip() {
            closeTooltip(false);
            tappedOpen = false;
          });

          scope.dayIndex = parseInt(scope.index);
          var currencyFilter = $filter('currency');
          scope.$on('sa:manageWorkPeriod:projectionsWeekProcessingStatus', function(event, data) {
            scope.data = data;
            if (data) {
              if (data.dayIndex !== scope.dayIndex) {
                $(elem).unbind('mousedown touchdown');
                if (tooltipOpenState) {
                  closeTooltip(true);
                }
              } else {
                $(elem).unbind('mousedown touchdown');
                bindClicks();
              }

              scope.dayAnalysis = scope.data.dayAnalysisDataByDay[scope.dayIndex];
              scope.budgetInDollarsFlag = scope.data.budgetHourDollarFlag;
              scope.currentNumber = (function() {
                if (scope.data.currentView === 'cost') {
                  scope.currentNumberVal = scope.dayAnalysis.laborCost;
                  return currencyFilter(scope.dayAnalysis.laborCost.toFixed(2));
                } else if (scope.data.currentView === 'laborHours') {
                  scope.currentNumberVal = scope.dayAnalysis.totalLaborHours;
                  return scope.dayAnalysis.totalLaborHours.toFixed(1) + ' hrs';
                } else if (scope.data.currentView === 'laborPercentage') {
                  if (scope.data.projections && scope.data.projections.byDay[scope.dayIndex] &&
                      scope.data.projections.byDay[scope.dayIndex].data.total &&
                      scope.dayAnalysis && scope.dayAnalysis.laborCost) {
                    if (scope.dayAnalysis.laborCost && scope.data.projections.byDay[scope.dayIndex].data.total.gross_revenue) {
                      scope.currentNumberVal = scope.dayAnalysis.laborCost / scope.data.projections.byDay[scope.dayIndex].data.total.gross_revenue * 100;
                      return scope.currentNumberVal.toFixed(1) + '%';
                    } else {
                      scope.currentNumberVal = null;
                      return null;
                    }
                  } else {
                    scope.currentNumberVal = null;
                    return null;
                  }
                } else if (scope.data.currentView === 'productivity') {
                  if (scope.data.projections && scope.data.projections.byDay[scope.dayIndex] &&
                      scope.data.projections.byDay[scope.dayIndex].data.total &&
                      scope.dayAnalysis && scope.dayAnalysis.totalLaborHours) {

                    var prodData = scope.data.projections.byDay[scope.dayIndex].data.total

                    var prod = null
                    if (prodData.labor_hours && prodData.labor_hours !== 0 && !Number.isNaN(prodData.labor_hours)) {
                      prod = prodData.gross_revenue / scope.dayAnalysis.totalLaborHours
                      scope.currentNumberVal = '$' + prod.toFixed(2)
                    } else {
                      return null
                    }
                    return scope.currentNumberVal
                  }
                }
              })();
              scope.dayPublishData = scope.dayAnalysis.publishData;

              setPublishStatusBarClasses();

              scope.currentProjection = (function() {
                if (scope.data.currentView === 'cost') {
                  if (scope.data.projections && scope.data.projections.byDay[scope.dayIndex] &&
                    scope.data.projections.byDay[scope.dayIndex].data &&
                    scope.data.projections.byDay[scope.dayIndex].data.total) {
                    if (scope.data.projections.byDay[scope.dayIndex].data.total.cost) {
                      scope.currentProjectionVal = scope.data.projections.byDay[scope.dayIndex].data.total.cost;
                      return currencyFilter(scope.currentProjectionVal);
                    } else {
                      scope.currentProjectionVal = null;
                      return null;
                    }
                  } else {
                    scope.currentProjectionVal = null;
                    return null;
                  }
                } else if (scope.data.currentView === 'laborHours') {
                  if (scope.data.projections && scope.data.projections.byDay[scope.dayIndex] &&
                    scope.data.projections.byDay[scope.dayIndex].data &&
                    scope.data.projections.byDay[scope.dayIndex].data.total) {
                    if (scope.data.projections.byDay[scope.dayIndex].data.total.labor_hours) {
                      scope.currentProjectionVal = scope.data.projections.byDay[scope.dayIndex].data.total.labor_hours;
                      return scope.currentProjectionVal.toFixed(1) + ' hrs';
                    } else {
                      scope.currentProjectionVal = null;
                      return null;
                    }
                  } else {
                    scope.currentProjectionVal = null;
                    return null;
                  }
                } else if (scope.data.currentView === 'laborPercentage') {
                  if (scope.data.projections && scope.data.projections.byDay[scope.dayIndex] &&
                    scope.data.projections.byDay[scope.dayIndex].data &&
                    scope.data.projections.byDay[scope.dayIndex].data.total) {
                    if (scope.data.projections.byDay[scope.dayIndex].data.total.cost && scope.data.projections.byDay[scope.dayIndex].data.total.gross_revenue) {
                      scope.currentProjectionVal = scope.data.projections.byDay[scope.dayIndex].data.total.cost / scope.data.projections.byDay[scope.dayIndex].data.total.gross_revenue * 100;
                      return scope.currentProjectionVal.toFixed(1) + '%';
                    } else {
                      scope.currentProjectionVal = null;
                      return null;
                    }
                  } else {
                    scope.currentProjectionVal = null;
                    return null;
                  }
                } else if (scope.data.currentView === 'productivity') {
                  if (scope.data.projections && scope.data.projections.byDay[scope.dayIndex] &&
                    scope.data.projections.byDay[scope.dayIndex].data &&
                    scope.data.projections.byDay[scope.dayIndex].data.total) {

                      var prodData = scope.data.projections.byDay[scope.dayIndex].data.total

                      var prod = null
                      if (prodData.labor_hours && prodData.labor_hours !== 0 && !Number.isNaN(prodData.labor_hours)) {
                        prod = prodData.gross_revenue / prodData.labor_hours
                        scope.currentProjectionVal = '$' + prod.toFixed(2)
                      } else {
                        return null
                      }
                      return scope.currentProjectionVal
                  }
                }
              })();

              // Note: This doesn't apply for the productivity state.
              if (scope.data.currentView !== 'productivity' && !_.isNull(scope.currentProjectionVal) && !_.isNull(scope.currentNumberVal)) {
                var theColor = UtilityService.calcColorWithGoal(scope.currentProjectionVal, scope.currentNumberVal, 100, 110);
                elem.find('.top_metric .metric_inner').css({
                  color: theColor
                });
              } else {
                elem.find('.top_metric .metric_inner').css({
                  color: ''
                })
              }

              scope.loadCompleted = true;
              scope.hideSpinner = true;

              setPublishStatusBarClasses();
            } else {
              scope.loadCompleted = false;
              scope.hideSpinner = false;
              setPublishStatusBarClasses();
            }
          });

          scope.openSetProjections = function($event) {
            $event.stopPropagation();
            $rootScope.$broadcast('sa:manageWorkPeriod:openSetProjections');
          };
        }
      };
    });
